
import logoHonda from '@assets/logos/honda-logo.png'
import logoHondaSmall from '@assets/logos/honda-logo-small.png'
import { ClientConfigInfo, FILTER_TYPES, METADADATA_LOAD, SurveyResponsesTab } from './configCommons'
import { DASHBOARDS, DASHBOARDS_CONFIGS } from '../dashboard/dashboardCommons'
import { commonFilterCriticalMoments } from '../dashboard/dashHelper'
import deafultHelpDefinition from '../help/defaultHelp'
import { omoikaneHonda } from '../omoikane/omoikaneHonda'


export const getHondaFilterCriticalMoments = (filtersData: Record<string, any>, userProfiles: UserProfile[], selectType: String): CriticalMoment[] => {
    const commonFiltersConfg = commonFilterCriticalMoments(filtersData, userProfiles, selectType)
    //console.log('retornando filtros de HA')
    //console.log(commonFiltersConfg)
    
    console.log("ENVIROMMENT -> "+ process.env.REACT_APP_ENVIRONMENT )

    return [
        ...commonFiltersConfg,
        //getServicioExternoCheckUp()
    ]
};

export const hondaConfigs: ClientConfigInfo = {
    //TODO: mejorar esta selection de ambiente por defecto es QA por ahi seria mejor que las url este ne env, el lugar de aca
    vocBackendUrl:  process.env.REACT_APP_ENVIRONMENT === 'PROD' ? 'https://honda-backend-voc.clientship.com/api/' : 'https://honda-backend-voc.qa.clientship.com/api/' ,
    //vocBackendUrl: 'http://localhost:9000/api/',
    lcmBackendUrl: process.env.REACT_APP_ENVIRONMENT === 'PROD' ? 'https://honda-backend-core.clientship.com/api/ui/' : 'https://honda-backend-core.qa.clientship.com/api/ui/',
    caseBackendUrl: process.env.REACT_APP_ENVIRONMENT === 'PROD' ? 'https://honda-backend-case.clientship.com/api/ui/' : 'https://honda-backend-case.qa.clientship.com/api/ui/',
    publicUrl: '/voc',
    logoSmall: logoHondaSmall,
    logo: logoHonda,
    filtersFromDateSubstract: 1,
    filtersToDateSubstract: 0,
    decimals: undefined,
    supportsInternationalization: false,
    filters: [
        FILTER_TYPES.DATES,
        FILTER_TYPES.GEOS,
        FILTER_TYPES.CRITICAL_MOMENTS,
        FILTER_TYPES.DYNAMIC
    ],
    menuDashboards: [DASHBOARDS.DEFAULT, DASHBOARDS.SOCIAL_LISTENING],
    sentimentCommentsIndicatorName: 'SENTIMENT_COMMENTS',
    getFilterCriticalMoments: getHondaFilterCriticalMoments,
    //getFilterCriticalMomentDefault: getFilterCriticalMomentDefault,
    dateFromParamName: 'dateFrom',
    dateToParamName: 'dateTo',
    msExcelReportExt: 'xls',
    geosRootId: 29,
    logicalsRootId: 0,
    criticalMomentsRootId: 29,
    criticalMomentFilterType: 'select',
    actionPlans: {
        geoLeafLevel: '',
        useWorstTags: true
    },
    omoikane: omoikaneHonda,
    useBackDashboards: false,
    metadata: [
        METADADATA_LOAD.GEOS,
        METADADATA_LOAD.CRITICAL_MOMENTS,
        METADADATA_LOAD.DYNAMIC_REPORT_FIELDS
    ],
    useSentimentCategories: true,
    useFlatGeoLocations: true,
    //useKeyPressGeoLocations: false,
    dashboards: {
        ...DASHBOARDS_CONFIGS.honda,
        default: DASHBOARDS_CONFIGS.honda[DASHBOARDS.DEFAULT]
    },
    staticDashboards: {},
    useDashboardDynamicPosition: true,
    surveyResponses: {
        url: 'survey-responses',
        type: 'post-context',
        tableColumns: undefined,
        tabs: [SurveyResponsesTab.ANSWERED],
        surveyDetailFields: [
            {
                position: 1,
                label: 'Área comentario',
                getValue: data => {
                    //console.log('custom field área!!!!!!!!!!')
                    //console.log(data)
                    const sentAnalysis = data
                    ?.questionResponses
                    ?.filter((q: any) => q.questionId === 999)
                    ?.map((q: any) => q.categories)
                    ?.flat(1)
                    ?.filter((item: any, index: any, arr: any) => arr.indexOf(item) === index)
                    //console.log(sentAnalysis)
                    return sentAnalysis?.map((sa: any) => sa === 'DEFAULT' ? 'Otros' : sa)?.join(' | ')
                }
            }
        ],
    },
    alerts: {
      useAlertWorkflows: true
    },
    help: deafultHelpDefinition,
    pageSize: 100,
    assistantConfig: {
        enable: true,
        buttonText: "💬",
        tenant: "honda"
    }
}
